

export const SET_AYUDA = "SET_AYUDA";

interface ISetAyuda {
    type: typeof SET_AYUDA
    ayuda: any
}

export type AyudaActionTypes = ISetAyuda
